import React, { Component } from 'react';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';
import { Col, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

export default class ConvertItemPrice extends Component {
  render() {
    const titleClass = classNames({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label', 'col-sm-5')
    return (
      <div>
        <div>{this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}</div>
        <Col xs={5}>
          <label className={titleClass}>
            {this.props.labelName}
          </label>
        </Col>
        <Col xs={1}>
          <label className="inlineLabel radioMargin" >
            <Input {...this.props.input} type="radio" value="FOB" checked={this.props.input.value === 'FOB'} />
          </label>
        </Col>
        <Col xs={3} className="custom-col-width">
          <label>
            <Translate value="fob" />
          </label>
        </Col>
        <Col xs={1}>
          <label className="inlineLabel radioMargin" >
            <Input {...this.props.input} type="radio" value="CIF" checked={this.props.input.value === 'CIF'} />
          </label>
        </Col>
        <Col xs={2}>
          <label>
            <Translate value="cif" />
          </label>
        </Col>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/convertItemPrice.jsx